export const StorageItems = {
  Language: "hi-five.language",
};
